import React, { useState, useEffect, Fragment } from "react";
import CantidadProductos from "./CantidadProductos";
import {
  Grid,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
} from "@material-ui/core";
import MethodGet from "../../Config/Services";
import { makeStyles } from "@material-ui/core/styles";
import Swal from "sweetalert2";
import ShoppingBasketIcon from "@material-ui/icons/ShoppingBasket";
import "./Product.css";

const useStyles = makeStyles((theme) => ({
  tableHead: {
    background: "#fafafa",
  },
  headCell: {
    fontWeight: 600,
    fontSize: "0.75rem",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    color: "#999",
    padding: "12px 14px",
    borderBottom: "2px solid #eee",
  },
}));

const BrandSales = (props) => {
  const {
    subtotal,
    productsBranded,
    saveProductsBranded,
    guardarTotal,
    totalDescuento,
    id,
    descuentoporcentaje,
    guardarTotalDescuento,
  } = props;

  useEffect(() => {
    actualizarTotal();
    calcularTotalDescuento();
  }, [subtotal, descuentoporcentaje, productsBranded]);

  const classes = useStyles();

  //Actualizar la cantidad de Productos
  const restarProductos = (i) => {
    const todosProducto = [...productsBranded];
    if (todosProducto[i].cantidad === 1) return;
    todosProducto[i].cantidad--;
    todosProducto[i].final_price =
      todosProducto[i].cantidad * todosProducto[i].price;
    saveProductsBranded(todosProducto);
  };

  const [branch, guardarBranch] = useState({});

  const calcularTotalDescuento = () => {
    let descuentoPorcentajeNew = 0;
    descuentoPorcentajeNew = descuentoporcentaje.discount;
    const descuento = (descuentoPorcentajeNew * subtotal) / 100;
    const TotalDescuento = subtotal - descuento;
    guardarTotalDescuento(Math.round(TotalDescuento));
  };

  useEffect(() => {
    let url = `/branches/${id}`;
    MethodGet(url)
      .then((res) => {
        guardarBranch(res.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const aumentarProductos = (i) => {
    const todosProducto = [...productsBranded];
    if (todosProducto[i].cantidad >= productsBranded[i].quantity) return;
    todosProducto[i].cantidad++;
    todosProducto[i].final_price =
      todosProducto[i].cantidad * todosProducto[i].price;
    saveProductsBranded(todosProducto);
  };

  const eliminarProductoVenta = (id) => {
    const todosProductos = productsBranded.filter(
      (venta) => venta.product_id !== id
    );
    if (todosProductos.length === 0) {
      localStorage.removeItem("EnterProducts");
    }
    saveProductsBranded(todosProductos);
  };

  const actualizarTotal = () => {
    if (productsBranded.length === 0) {
      guardarTotal(0);
      return;
    }
    let nuevoTotal = 0;
    productsBranded.map(
      (venta) => (nuevoTotal += venta.cantidad * venta.price)
    );
    guardarTotal(nuevoTotal);
  };

  const handleChangeQuantity = (e, i) => {
    const newQuantity = Number(e.target.value);
    const todosProducto = [...productsBranded];
    if (newQuantity > todosProducto[i].quantity) {
      Swal.fire({
        title: "Error",
        html: `<p>
          La cantidad no puede ser mayor al stock disponible, unicamente hay
          <b>
          ${todosProducto[i].quantity}
          </b>
          pzs de <b>
          ${todosProducto[i].name}  
          </b> 
           Disponibles 
          </p>`,
        icon: "error",
        showConfirmButton: false,
        timer: 3500,
      });
      return;
    }
    todosProducto[i].cantidad = newQuantity;
    todosProducto[i].final_price =
      todosProducto[i].cantidad * todosProducto[i].price;
    saveProductsBranded(todosProducto);
  };

  return (
    <>
      {!productsBranded.length ? (
        <div className="empty-products">
          <ShoppingBasketIcon />
          <p>Aún no has agregado productos</p>
          <p style={{ fontSize: "0.8rem", marginTop: 4 }}>
            Usa el código de barras o el selector para agregar
          </p>
        </div>
      ) : (
        <TableContainer>
          <Table size="small">
            <TableHead className={classes.tableHead}>
              <TableRow>
                <TableCell className={classes.headCell}>Producto</TableCell>
                <TableCell className={classes.headCell} align="center">Cantidad</TableCell>
                <TableCell className={classes.headCell} align="center">Stock</TableCell>
                <TableCell className={classes.headCell} align="right">Precio</TableCell>
                <TableCell className={classes.headCell} align="right">Total</TableCell>
                <TableCell className={classes.headCell} align="center" style={{ width: 50 }}></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {productsBranded.map((venta, index) => (
                <CantidadProductos
                  key={venta.product_id || index}
                  venta={venta}
                  handleChangeQuantity={handleChangeQuantity}
                  restarProductos={restarProductos}
                  aumentarProductos={aumentarProductos}
                  eliminarProductoVenta={eliminarProductoVenta}
                  index={index}
                />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </>
  );
};

export default BrandSales;
